import { CheckboxCard } from "@/src/components/cards";
import SearchKeyHighliter from "@/src/components/seachkeyHighlighter";
import {
  Appointment,
  CardType,
  Exam,
  Patient,
  Service,
  SimpleExam,
} from "@/src/data/allTypes";
import { getItemId, getUserShortName, uid } from "@/src/utils/utils";
import moment from "moment";
import { openExamActionsDialog } from "../exams/examActionsDialog";
import { ExamDemandButton } from "../exams/examDemandButton";
import ExamSamplesButton from "../exams/examSamplesButton";
import { openExamEditDrawer, openExamsVisualisationDrawer } from "../exams/openExamVisualisationDrawer";

export function ExamCard({
  exam,
  patient,
  type,
  searchKey,
  allExams,
  allAppointments,
  allServices,
  onChange,
}: {
  exam: SimpleExam | Exam;
  patient: Patient;
  type?: CardType;
  searchKey?: string;
  allExams: (SimpleExam | Exam)[];
  allAppointments: Appointment[];
  allServices: Service[];
  onChange: () => void;
}) {
  const index = allExams.findIndex(
    (existingExam) => getItemId(existingExam) == getItemId(exam)
  );
  return (
    <CheckboxCard
      key={uid()}
      color={type || "orange"}
      status={exam.status == "finished" ? "active" : "inactive"}
      className={`${
        exam.status == "finished" ? "" : "empty"
      }`}
      title={
        <SearchKeyHighliter searchKey={searchKey}>
          {exam.reference?.name}
        </SearchKeyHighliter>
      }
      subTitle={getUserShortName(exam?.creator)}
      onClick={async (e) => {
        e.stopPropagation();
        if (exam.status == "finished")
          return await openExamsVisualisationDrawer({
            exams: allExams || [],
            index,
            onEdit: async () => {
              onChange();
            },
          });

          await openExamEditDrawer({
            examId: exam.id,
            onConfirm: async (newExam) => {
              onChange();
            },
          });
      }}
      onMore={async () => {
        await openExamActionsDialog({
          allAppointments: allAppointments || [],
          exams: allExams || [],
          index,
          patient,
          services: allServices || [],
          onChange: async () => {
            onChange();
          },
        });
      }}
    >
      <div className="c1 gap5" style={{ maxWidth: "400px" }}>
        <div className="gray">{moment(exam?._date).format("LL HH:mm")}</div>
        <ExamDemandButton
          patient={patient}
          exam={exam}
          isHospitalized={true}
          allAppointments={allAppointments || []}
          allServices={allServices || []}
          onChange={async () => {
            onChange();
          }}
        ></ExamDemandButton>
        <ExamSamplesButton
          patient={patient}
          exam={exam}
          onChange={async () => {
            onChange();
          }}
        ></ExamSamplesButton>
      </div>
    </CheckboxCard>
  );
}
